export function WhyChoose() {
  const benefits = [
    {
      image: 'https://public.readdy.ai/ai/img_res/84273ec995100d32a7a50cf174678281.jpg',
      tag: 'Acolhimento',
      title: 'Ambiente Seguro e Sigiloso',
      description: 'Espaço projetado para seu conforto e privacidade total, onde você pode se expressar livremente sem julgamentos.'
    },
    {
      icon: 'ri-time-line',
      tag: 'Flexibilidade',
      title: 'Horários que se Adaptam a Você',
      description: 'Atendimento de segunda a sexta, das 8h às 22h, presencial ou online, para se encaixar na sua rotina.'
    },
    {
      image: 'https://readdy.ai/api/search-image?query=therapy%20notebook%20journal%20on%20wooden%20desk%20with%20pen%20professional%20notes%20clean%20organized%20workspace%20minimalist%20aesthetic%20natural%20light%20therapeutic%20tools%20calm%20setting%20simple%20composition%20focused%20details&width=600&height=400&seq=benefit002&orientation=landscape',
      tag: 'Resultados',
      title: 'Transformação em Poucas Semanas',
      description: 'Com seu comprometimento ativo no processo terapêutico, resultados significativos aparecem rapidamente.'
    }
  ];

  const additionalBenefits = [
    {
      icon: 'ri-message-3-line',
      title: 'Acompanhamento Fora das Sessões',
      description: 'Suporte contínuo para garantir seu progresso entre os encontros.'
    },
    {
      icon: 'ri-map-pin-line',
      title: 'Localização Privilegiada',
      description: 'Estacionamento no local e ao lado da Estação Morumbi para sua comodidade.'
    }
  ];

  return (
    <section className="py-24 bg-[#F0F9F7]">
      <div className="max-w-7xl mx-auto px-6 lg:px-20">
        <div className="flex flex-col lg:flex-row items-start justify-between mb-16 gap-8">
          <h2 className="text-4xl lg:text-5xl font-bold text-[#2C2C2C]" style={{ fontFamily: 'Inter, sans-serif' }}>
            Por Que Escolher<br />Meu Atendimento?
          </h2>
          <p className="text-lg text-[#6B6B6B] leading-relaxed lg:w-3/5">
            Ofereço uma abordagem humanizada e profissional, focada em criar um espaço onde você se sinta verdadeiramente acolhido e compreendido. Cada sessão é pensada para promover sua transformação pessoal com respeito, empatia e técnicas comprovadas.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-8">
          {benefits.map((benefit, index) => (
            <div
              key={index}
              className="bg-white rounded-2xl overflow-hidden shadow-lg hover:shadow-xl transition-all duration-300 group"
            >
              {benefit.image ? (
                <div className="w-full h-64 overflow-hidden">
                  <img
                    src={benefit.image}
                    alt={benefit.title}
                    className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  />
                </div>
              ) : (
                <div className="w-full h-64 bg-gradient-to-br from-[#F0F9F7] to-[#E0F2EF] flex items-center justify-center">
                  <div className="w-24 h-24 flex items-center justify-center bg-white rounded-full shadow-md">
                    <i className={`${benefit.icon} text-5xl text-[#7DD3C0]`}></i>
                  </div>
                </div>
              )}
              <div className="p-6">
                <span className="inline-block bg-[#E0F2EF] text-[#7DD3C0] text-sm font-medium px-4 py-1 rounded-full mb-4">
                  {benefit.tag}
                </span>
                <h3 className="text-xl font-bold text-[#2C2C2C] mb-3">{benefit.title}</h3>
                <p className="text-[#6B6B6B] leading-relaxed">{benefit.description}</p>
              </div>
            </div>
          ))}
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {additionalBenefits.map((benefit, index) => (
            <div
              key={index}
              className="bg-white rounded-2xl p-6 shadow-md hover:shadow-lg transition-all duration-300 flex items-start gap-4"
            >
              <div className="w-12 h-12 flex items-center justify-center bg-[#E0F2EF] rounded-full flex-shrink-0">
                <i className={`${benefit.icon} text-2xl text-[#7DD3C0]`}></i>
              </div>
              <div>
                <h4 className="text-lg font-bold text-[#2C2C2C] mb-2">{benefit.title}</h4>
                <p className="text-[#6B6B6B]">{benefit.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}